import React, { useState, useEffect } from "react";
import OrderForm from "./OrderForm";
import { Dialog, Grid, CircularProgress, withStyles, Paper } from "@material-ui/core";
import * as Yup from "yup";
import * as actions from "./store/orderActions";
import { connect } from "react-redux";
import { BackButton } from '../../sc-utilities';
import { statuses, types } from '../../sc-utilities/OrderUtilities';
import { hasPermission } from "../../sc-utilities";
import History from "../../../History";
import AppLogoLoading from '../../sc-logo';
import * as groupActions from "../../sc-group/Group/store/groupActions";


const styles = theme => ({
  root: {
    width: 'auto',
    height: 'auto',
    padding: theme.spacing(2),
    paddingRight: theme.spacing(6),
    margin: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      margin: 0,
      paddingRight: 0,
    },
  },
  paper: {
    backgroundColor: "transparent",
    boxShadow: "none",
    overflow: "hidden",
    alignItems: "center"
  },
  progress: {
    width: `398px`,
    height: "400px"
  },
  typographyTo: {
    marginTop: "5px",
    color: theme.palette.buttonText.default
  },
  typography: {
    marginTop: "5px",
    color: theme.palette.buttonText.default,
    position: "absolute",
    top: "40%",
    right: "0",
    textAlign: "center",
    left: "0"
  },
  logo: {
    width: "250px",
    margin: "10px"
  }
});

const OrderCreate = props => {
  const { classes, loading, activeCustomer, translations, onListFilePatterns, onCreateOrder, onListReportData, fetchGroups, permissions } = props;

  const [data, setData] = useState({
    filePatterns: [],
    reportInformation: [],
    loadingData: true
  });
  const [groups, setGroups] = useState(null);


  useEffect(() => {
    const fetchData = async () => {
      let filePatternData = await onListFilePatterns({
        ActiveCustomerID: activeCustomer
      });
      let reportInformationData = await onListReportData({
        ActiveCustomerID: activeCustomer
      });

      setData({
        filePatterns: filePatternData,
        reportInformation: reportInformationData,
        loadingData: false
      });
    };
    fetchData();
    return () => { };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const getGroups = async () => {
      const resultGroups = await fetchGroups({ ActiveCustomerID: activeCustomer });
      if (resultGroups) {
        let groupsToSet = resultGroups.data.map(group => ({ value: group.GroupID, displayValue: group.Name }));
        if (hasPermission(permissions, 'access_all_orders_on_customer')) {
          groupsToSet = [...groupsToSet, { value: 'n/a', displayValue: 'n/a' }];
        }
        setGroups(groupsToSet);
      }
    }

    if (hasPermission(permissions, 'group_list')) {
      getGroups();
    }
  }, [fetchGroups, activeCustomer, permissions]);

  const handleSubmit = async data => {
    if (data["ReportDataID"] === "reportInfo_none") {
      data["ReportDataID"] = null;
    }
    if (data["FilePatternID"] === "filePattern_none") {
      data["FilePatternID"] = null;
    }
    if (data['GroupID'] === 'n/a') {
      data['GroupID'] = null;
    }

    let result = await onCreateOrder({
      ...data,
      ProjectID: data['ProjectID'] === '' ? null : data['ProjectID'],
      ActiveCustomerID: activeCustomer,
    });

    if (result) {
      History.goBack();
    }
  };

  let initialValues = {
    Name: "",
    Description: "",
    ReportDataID: data.reportInformation ? data.reportInformation[0]?.value : '',
    FilePatternID: data.filePatterns ? data.filePatterns[0]?.value : '',
    ProjectID: '',
    Status: statuses && statuses[0] ? statuses[0].value : '',
    Type: types && types[0] ? types[0].value : '',
    ErasureReportSignature: false,
    DefaultLanguage: 'en',
    GroupID: groups?.map(group => group?.value)?.includes('n/a') ? 'n/a' : groups?.[0]?.value ?? null
  };
  let formSettings = {
    Validation: {
      Name: Yup.string().required("Required"),
      Description: Yup.string().notRequired("Not required"),
      DefaultLanguage: Yup.string().required("Required")
    },
    FormTitle: translations["create_order"] || "Create order",
    ButtonSubmit: {
      Title: translations["save"] || "SAVE"
    }
  };
  return (
    <Paper className={classes.root} >
      <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={data.loadingData}
        PaperProps={{
          classes: {
            root: classes.paper
          }
        }}
      >
        <AppLogoLoading />
      </Dialog>
      {!data.loadingData ?
        <Grid container spacing={10}>
          <Grid item xs={12}>
            {BackButton(translations)}

            <OrderForm
              formSettings={formSettings}
              initialValues={initialValues}
              handleSubmit={handleSubmit}
              loading={loading}
              create={true}
              translations={translations}
              statuses={statuses}
              types={types}
              reportInformation={data.reportInformation}
              filePatterns={data.filePatterns}
              groups={groups}
            ></OrderForm>
          </Grid>
        </Grid>
        : <><CircularProgress
          variant="determinate"
          color="primary"
          size={28}
        />
        </>}

    </Paper>
  );
};
const mapStateToProps = state => {
  return {
    activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
    translations:
      state.translate && state.translate.translations
        ? state.translate.translations.activeTranslations || {}
        : {},
    permissions: state?.core?.login?.permissions || []
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onListFilePatterns: id => dispatch(actions.listFilePatterns(id)),
    onListReportData: id => dispatch(actions.listReportInformation(id)),
    onCreateOrder: order => dispatch(actions.createOrder(order)),
    fetchGroups: params => dispatch(groupActions.fetchGroups(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(OrderCreate));

